import React, { BaseSyntheticEvent } from 'react'
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import PatientMedicationsContent from '../pageContent/PatientMedications.content'
import { chevronBackOutline } from 'ionicons/icons'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'

const PatientMedications: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.PATIENT_INFO_ROUTE)
  }

  return (
    <IonPage id='PatientMedicationsPage'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('patientMedications.PatientMedications')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent id='pn-medications-content' color='light' fullscreen>
        <PatientMedicationsContent />
      </IonContent>
    </IonPage>
  )
}

export default PatientMedications
